var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1",
    d: "M16 1L1 16"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    d: "M1 1l15 15"
  }))));
}
export default SvgCloseIcon;